import { api } from './axios'
import type { TurmaDetalhes, TurmaListItem } from '@/types'

export interface FiltrosDeTurmas {
  page: number
  limit: number
  statusTurma?: 'SOLICITADA' | 'ATIVA'
}

export interface RespostaDeTurmas {
  count: number
  rows: TurmaListItem[]
  page: number
  limit: number
  totalPages: number
  solicitacoesPendentes: number
}

export interface ValoresDaSolicitacao {
  nomeTurma: string
  observacoes: string
  pagadorCpfCnpj: string
  pagadorNome: string
  pagadorEhOParceiro: boolean
  emitirNotaParaPagador: boolean
}

export async function listarTurmas(filtros: FiltrosDeTurmas): Promise<RespostaDeTurmas> {
  const response = await api.get<RespostaDeTurmas>('/turmas/all', { params: filtros })
  return response.data
}

export async function getTurma(turmaId: number): Promise<TurmaDetalhes> {
  const response = await api.get<TurmaDetalhes>('/turmas/id', { params: { turmaId } })
  return response.data
}

export async function solicitarTurma(
  valores: ValoresDaSolicitacao,
  arquivo: File | null,
): Promise<TurmaListItem> {
  const form = new FormData()
  if (arquivo) form.append('arquivo', arquivo)
  Object.entries(valores).forEach(([campo, valor]) => form.append(campo, String(valor)))
  const response = await api.post<TurmaListItem>('/turmas/solicitacao', form)
  return response.data
}

export async function cancelarSolicitacao(turmaId: number): Promise<void> {
  await api.delete(`/turmas/${turmaId}/solicitacao`)
}

export async function trocarArquivo(turmaId: number, arquivo: File): Promise<TurmaListItem> {
  const form = new FormData()
  form.append('arquivo', arquivo)
  const response = await api.put<TurmaListItem>(`/turmas/${turmaId}/solicitacao/arquivo`, form)
  return response.data
}

export async function getNonceNotaFiscal(
  turmaId: number,
): Promise<{ notaFiscalId: number; nonce: string }> {
  const response = await api.get<{ notaFiscalId: number; nonce: string }>(
    `/notas-fiscais/turma/${turmaId}/nonce`,
  )
  return response.data
}
